import React, { useState, useEffect } from "react";
import "./Home.css";
import nourTuneLogo from "../../nourtunelogohome.png";
import telelumiereLogo from "../../nourtunelogohome.png";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Hero from "./Hero";
import Footer from "./Footer";

const Home = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    // Set launch date: 37 days, 12 hours, 46 minutes from now
    const launchDate = new Date();
    launchDate.setDate(launchDate.getDate() + 37);
    launchDate.setHours(launchDate.getHours() + 12);
    launchDate.setMinutes(launchDate.getMinutes() + 46);

    const interval = setInterval(() => {
      const now = new Date();
      const difference = launchDate - now;

      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({});
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  const handleNotifySubmit = (e) => {
    e.preventDefault();
    // Handle email submission logic here
    setIsSubmitted(true);
    setEmail("");
    setTimeout(() => setIsSubmitted(false), 3000);
  };

  return (
    <div className="home light">
      {/* Navigation */}
      <Navbar />
      {/* Hero Section */}
      <Hero />
      {/* Features Section */}
      <div className="home-items-container"></div>
      <section id="features" className="features">
        <h2 className="section-title mb-5">Why Choose NourTune?</h2>
        <p className="coming-soon-text">
          NourTune is currently in development, but we're working hard to bring
          you the ultimate rhyme platform. <br />
          Be the first to know when we launch!
        </p>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🎤</div>
            <h3>Artist Rhyme Library</h3>
            <p>Browse rhymes written and performed by singers and artists.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">📂</div>
            <h3>Categories & Occasions</h3>
            <p>Find rhymes for weddings, worship, celebrations, and more.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">💾</div>
            <h3>Save & Download</h3>
            <p>Save your favorite rhymes and download them to your device.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">👤</div>
            <h3>Personal Profile</h3>
            <p>Create your account to organize your rhyme collection.</p>
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="coming-soon" id="launch">
        <div className="coming-soon-content">
          <h2 className="section-title">Get Ready for Launch</h2>
          <p className="coming-soon-text">
            NourTune is currently in development, but we're working hard to
            bring you the ultimate rhyme platform. <br />
            Be the first to know when we launch!
          </p>

          <div className="launch-timer">
            {timeLeft.days !== undefined ? (
              <>
                <div className="timer-item">
                  <span className="timer-number">{timeLeft.days}</span>
                  <span className="timer-label">Days</span>
                </div>

                <div className="timer-item">
                  <span className="timer-number">{timeLeft.hours}</span>
                  <span className="timer-label">Hours</span>
                </div>

                <div className="timer-item">
                  <span className="timer-number">{timeLeft.minutes}</span>
                  <span className="timer-label">Minutes</span>
                </div>

                <div className="timer-item">
                  <span className="timer-number">{timeLeft.seconds}</span>
                  <span className="timer-label">Seconds</span>
                </div>
              </>
            ) : (
              <h3>🎉 We Are Live!</h3>
            )}
          </div>
          <button className="get-notified mt-3">Get Notified</button>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Home;
